const storageService = {
  putStorage(key, value) {
    if (value.constructor === [].constructor || value.constructor === {}.constructor) {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.setItem(key, value)
    }
  },
  getStorage(key, def = '') {
    const item = localStorage.getItem(key)
    if (!item) return def
    try {
      return JSON.parse(item)
    } catch (e) {
      return item
    }
  },
  removeStorage(key) {
    localStorage.removeItem(key)
  },
  getCookie(name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  },
  setCookie(name, value, num = 1, type = 'day') {
    try {
      let expires = ''
      let cookieDomain = ''

      if (location.hostname !== 'localhost') {
        const a = document.createElement('a')
        a.href = import.meta.env.VITE_BASE_URL
        cookieDomain = a.hostname
      }

      const date = new Date()
      if (type === 'day') {
        date.setTime(date.getTime() + num * 24 * 60 * 60 * 1000)
        expires = '; expires=' + date.toUTCString()
      } else if (type === 'minute') {
        date.setTime(date.getTime() + num * 60 * 1000)
        expires = '; expires=' + date.toUTCString()
      }

      document.cookie = name + '=' + (value || '') + expires + '; path=/; domain=' + cookieDomain
    } catch (err) {
      console.error(err)
    }
  },
  uploadUrl(path) {
    // path = (path||'').replaceAll("/", ":")
    return import.meta.env.VITE_FILE_UPLOAD_URL + path
  },
  cryptUrl(path) {
    path = (path||'').replaceAll("/", ":")
    return import.meta.env.VITE_FILE_CRYPT + path
  },
  fileUrl(path) {
    return import.meta.env.VITE_IMAGE_URL + path
  },
  downloadUrl(){
    return import.meta.env.VITE_DOWNLOAD_URL
  },
  downloadUrlv2(){
    return import.meta.env.VITE_DOWNLOAD_URL_V2
  },

  openDoc(path) {
    return import.meta.env.VITE_DOCUMENT_URL + path
  },
  compressImage(file, quality = 0.8, maxWidth = 1600) {
    return new Promise((resolve) => {
      const img = new Image()
      img.src = URL.createObjectURL(file)

      img.onload = () => {
        const scale = Math.min(1, maxWidth / img.width)
        const canvas = document.createElement('canvas')
        canvas.width = img.width * scale
        canvas.height = img.height * scale

        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

        canvas.toBlob(
          (blob) => resolve(new File([blob], file.name, { type: file.type })),
          file.type,
          quality,
        )
      }
    })
  },
}

export { storageService}
